import { PartnerActiveClientsPage } from 'containers/PartnerActiveClientsPage';
import { PartnerCancelledClientsPage } from 'containers/PartnerCancelledClientsPage';
import React from 'react';
import { Redirect, Route, Switch } from 'react-router';

import { routes } from 'utils/routes';

export const PartnerDashboardBody = () => {
  return (
    <Switch>
      <Route path={routes.clientsActivePattern()}>
        <PartnerActiveClientsPage />
      </Route>
      <Route path={routes.clientsCancelledPattern()}>
        <PartnerCancelledClientsPage />
      </Route>
      <Route path="/">
        <Redirect to={routes.clientsActive()} />
      </Route>
    </Switch>
  );
};
